import { render, staticRenderFns } from "./SectionsTab.vue?vue&type=template&id=48b04424&"
import script from "./SectionsTab.vue?vue&type=script&lang=js&"
export * from "./SectionsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports